var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autologin-info"},[(_vm.data)?[_c('table',{staticClass:"autologin-info__container"},[_vm._m(0),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.name))]),_c('td',[_vm._v(_vm._s(item.value))])])}),0)])]:_c('no-data')],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Key")]),_c('th',[_vm._v("Value")])])])
}]

export { render, staticRenderFns }